import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch("/assets/data/hp-products.json")
      .then((res) => res.json())
      .then((data) => {
        // Show all products (no filtering)
        setProducts(data);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  // Countdown
  const [timeLeft, setTimeLeft] = useState(getCountdown());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Add to cart logic
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  // Helper: Format category into sentence case
  const formatCategory = (str) => {
    return str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const productsWithRandomData = useMemo(() => {
    return products.map((item) => {
      const total = Math.floor(Math.random() * 50) + 10;
      const sold = Math.floor(Math.random() * total);

      const rating = (Math.random() * 1 + 4).toFixed(1);
      const reviews = Math.floor(Math.random() * 400) + 100;

      const tagPool = [
        "Wireless Printing",
        "Best Seller",
        "High Speed",
        "Eco Mode",
        "Smart Print",
      ];

      const randomTags = tagPool.sort(() => 0.5 - Math.random()).slice(0, 3);

      return {
        ...item,
        rating,
        reviews,
        features: randomTags,
        sold,
        stock: true,
        formattedCategory: formatCategory(item.category || "Printer"),
      };
    });
  }, [products]);

  return (
    <section className="deals-weeek pt-30 pb-30 sec-grey">
      <div className="container container-lg">
        <div className="p-24 text-center mb-30">
          <h4 style={{ fontSize: "32px", fontWeight: "700", color: "#222" }}>
            Best Printers Deals
          </h4>
          <p
            style={{
              color: "#555",
              fontSize: "15px",
              maxWidth: "700px",
              margin: "10px auto",
              lineHeight: "1.7",
            }}
          >
            Save on the most-trusted printers across the world for fast
            delivery, genuine ink, expert support.
          </p>
        </div>

        {/* PRODUCT GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "25px",
            marginBottom: "40px",
          }}
        >
          {productsWithRandomData.map((item) => (
            <div key={item.id} className="deal-card">
              <Link to={`/product/${item.id}`} className="card-image">
                <img
                  src={
                    item.imageUrl ||
                    "/assets/images/thumbs/product-two-img1.png"
                  }
                  alt={item.name}
                />
                <span className="badge">🔥 Trending</span>
              </Link>

              <div className="card-content">
                <p className="card-category">{item.formattedCategory}</p>

                <Link to={`/product/${item.id}`} className="card-title">
                  {item.name}
                </Link>

                <p className="card-description">
                  {item.description?.split(" ").slice(0, 10).join(" ") + "..."}
                </p>

                <div className="card-tags">
                  {item.features.map((tag, i) => (
                    <span key={i} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="card-footer">
                  <div>
                    {item.oldPrice && (
                      <span className="old-price">${item.oldPrice}</span>
                    )}
                    <span className="price">${item.price}</span>
                  </div>

                  <button
                    className="cart-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add <i className="ph ph-shopping-cart" />
                  </button>
                </div>

                <div className="card-rating">
                  <span className="stars">⭐ {item.rating}</span>
                  <span className="stock">✔ In Stock</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CSS */}
      <style>{`
       
      /* ================= DEAL CARD ================= */
.deal-card {
  background: #f3f6fb;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  transition: transform .25s ease, box-shadow .25s ease;
}

.deal-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 32px rgba(0,0,0,0.14);
}

/* IMAGE */
.card-image {
  background: #fff;
  padding: 24px;
  display: flex;
  justify-content: center;
  position: relative;
}

.card-image img {
  width: 75%;
  transition: transform .3s ease;
}

.deal-card:hover .card-image img {
  transform: scale(1.05);
}

.badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #0b5ed7;
  color: #fff;
  font-size: 11px;
  padding: 6px 10px;
  font-weight: 700;
}

/* CONTENT */
.card-content {
  padding: 18px 20px 20px;
  background:#f3f6fb;
}

.card-category {
  font-size: 12px;
  font-weight: 700;
  color: #0b5ed7;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #111;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  line-height: 1.3;
}

.card-title:hover {
  color: #0b5ed7;
}

.card-description {
  font-size: 14px;
  color: #555;
  margin-bottom: 14px;
  line-height: 1.6;
}

/* TAGS */
.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.tag {
  font-size: 11px;
  padding: 6px 10px;
  background: #f1f5ff;
  color: #0b5ed7;
  font-weight: 600;
}

/* FOOTER */
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.price {
  font-size: 22px;
  font-weight: 800;
  color: #111;
}

.old-price {
  font-size: 13px;
  color: #999;
  text-decoration: line-through;
  display: block;
}

/* BUTTON */
.cart-btn {
  background: #0b5ed7;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background .25s ease;
}

.cart-btn:hover {
  background: #084bb0;
}

/* RATING */
.card-rating {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.stars {
  color: #f59e0b;
  font-weight: 700;
}

.stock {
  color: #16a34a;
  font-weight: 700;
}


      `}</style>
    </section>
  );
};

export default DealsOne;
